import WelcomeForm from './pages/Promoter/WelcomeForm';
import { selectConfig } from './redux/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConfigs } from './redux/Slice/configSlice';
import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import Main from './pages/Main';
import './styles/styles.scss';

function App() {
  const { isLoading } = useSelector(selectConfig);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchConfigs());
  }, [dispatch]);

  if (isLoading) {
    return null;
  }

  return (
    <div className='App'>
      <Routes>
        <Route path='/' element={<Main actualScreen='Promoter' />} />
        <Route path='/soyreferido' element={<Main actualScreen='ValidateIdu' />} />
      </Routes>
    </div>
  );
}

export default App;
